import ActionTypes from "./actionTypes";
import store from "./store";


const updateGameState = (payload) => store.dispatch( {type: ActionTypes.GAME_STATE_UPDATE, payload} )


export {updateGameState}